module.exports = __webpack_public_path__ + "img/250329915_3097835590542064_7711569247074721060_n-499x800.9931bbf3.jpg";